export default __webpack_public_path__ + "locales/fi/InfoPanel.json?hash=fa3d56f2ddfb8ed1dc1cf962a40769db";